import { render, staticRenderFns } from "./ServiceBannerTable.vue?vue&type=template&id=6bcd49ee"
import script from "./ServiceBannerTable.vue?vue&type=script&lang=js"
export * from "./ServiceBannerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports